import React from 'react';
import {
  NavbarDocsIcon,
  NavbarDocumentScanIcon,
  NavbarHamburgerIcon,
  NavbarMessagesIcon,
  NavbarNotificationIcon,
  NavbarPrinterIcon,
  NavbarUserIcon,
} from '../../icons/TourIcons';
import styles from '../../stylesheets/mobileNavbar.module.scss';

interface NavIconProps {
  badge?: number;
  children: React.ReactNode;
}

const NavIcon = ({ badge, children }: NavIconProps) => (
  <div className={styles.iconButton}>
    {children}
    {badge != null && badge > 0 && (
      <span className={styles.badge}>{badge}</span>
    )}
  </div>
);

interface MobileNavbarProps {
  inboxCount?: number;
  scansCount?: number;
  notificationCount?: number;
}

const MobileNavbar = ({
  inboxCount = 10,
  scansCount = 1,
  notificationCount = 3,
}: MobileNavbarProps) => {
  return (
    <nav className={styles.navbar}>
      <button type="button" className={styles.hamburger} aria-label="Menu">
        <NavbarHamburgerIcon />
      </button>
      <div className={styles.rightSection}>
        <div className={styles.iconsGroup}>
          <NavIcon badge={inboxCount}>
            <NavbarMessagesIcon />
          </NavIcon>
          <NavIcon badge={scansCount}>
            <NavbarDocumentScanIcon />
          </NavIcon>
          <NavIcon>
            <NavbarDocsIcon />
          </NavIcon>
          <NavIcon>
            <NavbarPrinterIcon />
          </NavIcon>
          <NavIcon badge={notificationCount}>
            <NavbarNotificationIcon />
          </NavIcon>
        </div>
        <div className={styles.avatarButton}>
          <div className={styles.avatar}>
            <NavbarUserIcon />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MobileNavbar;
